<template>
  <div class="all">
    <router-view></router-view>
  </div>
</template>

<script setup>
import { ref } from 'vue';
import { jsToCssVariable } from '@/utils.js'
import * as themeService from '@/services/theme.service.js';
import useThemeStore from '@/stores/theme.store.js';

const themeStore = useThemeStore();

function changeFavicon(newIcon) {
  let iconDOM = document.getElementById('favicon');
  iconDOM.setAttribute('href', newIcon);
}

async function init() {
  let theme = await themeService.getTheme();
  themeStore.setTheme(theme);

  for (let color in theme.colors) {
    document.body.style.setProperty(
      jsToCssVariable(color),
      theme.colors[color]
    );
  }
  changeFavicon(theme.favicon);
}

init();
</script>

<style>
</style>
